import Swiper from "swiper/bundle";
import $ from "jquery";
import CONSTANT from "../../common/js/_constant";

const browseArticle = {
  variables: {
    swiperElem: null,
    articleSwiperWrap: $("#articleSwiperWrap"),
    observer: null,
    sections: [],
    url: window.location.href,
    isManualClick: false,
    manualClickTimer: null,
  },
  methods: {
    addSwiper: (element) => {
      browseArticle.variables.swiperElem = new Swiper(
        $(element).find(".browse-article__swiper-box--swiper").get(0),
        {
          spaceBetween: 32,
          // slides are <a> links: swiper's role="group" is not allowed on them and its
          // "1 / 10" aria-label would replace the link's own name
          a11y: {
            slideRole: null,
            slideLabelMessage: null,
          },
          navigation: {
            nextEl: ".browse-article__next-button",
            prevEl: ".browse-article__prev-button",
            disabledClass: "swiper-button-disabled",
          },
          breakpoints: {
            0: {
              slidesPerView: 3,
              spaceBetween: 8,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
          },
        }
      );

      // Set initial disabled state and keep it in sync on every slide change.
      browseArticle.methods.updateNavState(element);
      browseArticle.variables.swiperElem.on("slideChange", () => {
        browseArticle.methods.updateNavState(element);
      });
    },

    updateNavState: (element) => {
      const swiper = browseArticle.variables.swiperElem;
      const $next = $(element).find(".browse-article__next-button");
      const $prev = $(element).find(".browse-article__prev-button");

      $next.toggleClass("swiper-button-disabled", swiper.isEnd);
      $prev.toggleClass("swiper-button-disabled", swiper.isBeginning);
    },

     slideClick: (ele) => {
       $(ele).find(".browse-article__swiper-wrapper--slide").on('click', (e)=>{
        let obj = browseArticle.methods.dataLayerObj($(e.currentTarget).find('.browse-article__label').data('text'));
        createDataLayer("tileClick", obj);
       });
       $(ele).find('.browse-article__prev-button').on('click', function(e) {
            if ($(this).hasClass('swiper-button-disabled')) {return;}
            let  buttonText="Previous";
            var obj = browseArticle.methods.dataLayerObj(buttonText);
            createDataLayer('List_Scroll_Previous', obj);
        });
        $(ele).find('.browse-article__next-button').on('click', function(e) {
            if ($(this).hasClass('swiper-button-disabled')) {return;}
            let  buttonText="Next";
            var obj = browseArticle.methods.dataLayerObj(buttonText);
            createDataLayer('List_Scroll_Next', obj);
        });
    },

    handleClick: (element) => {
      $(element)
        .find(".browse-article__swiper-wrapper--slide")
        .each((idx, slide) => {
          idx == 0 && $(slide).addClass("selected");
          $(slide).on(CONSTANT.eventsListners.CLICK, (e) => {
            $(element)
              .find(".browse-article__swiper-wrapper--slide")
              .removeClass("selected");
            $(slide).addClass("selected");

            // Center the active tab dynamically based on the current slidesPerView
            // (changes between 1.4 on sticky-mobile and 3/3.2 on normal/desktop).
            const spv = browseArticle.variables.swiperElem.params.slidesPerView;
            const offset = Math.floor((spv - 1) / 2);
            browseArticle.variables.swiperElem.slideTo(Math.max(0, idx - offset));

            // Lock the IntersectionObserver for 2.5 s so the anchor-scroll
            // that follows the click doesn't trigger a second slideTo while
            // sections cross the viewport threshold.
            browseArticle.variables.isManualClick = true;
            clearTimeout(browseArticle.variables.manualClickTimer);
            browseArticle.variables.manualClickTimer = setTimeout(() => {
              browseArticle.variables.isManualClick = false;
            }, 2500);
          });
        });
    },

    dataLayerObj: function (e) {
      var obj = {
          'articleName' : "",
          'blogCategory' : "",
          'blogPageCategory' : "",
          'buttonText' : e ? e:'',
          'pageSection' : "Browse articles by category",
          'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? browseArticle.variables.url.includes("blog") ? "Blogs" : browseArticle.variables.url.substring(browseArticle.variables.url.indexOf(".com/"), browseArticle.variables.url.lastIndexOf('/')  === ".com") && !browseArticle.variables.url.substring(browseArticle.variables.url.indexOf(".com/"), browseArticle.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
          'planOption' : "",
          'productCategory' : "",
          'productName' : "",
          'question' : "",
          'searchTerm' : "",
          'videoTitle' : "",
          'bannerName' : "",
          'bannerType' : ""
      };
      return obj;
  },

    scrollFunction() {
      const $stickyElement = $("#browseArticleSection");
      const stickyTop = $stickyElement.offset().top;

      // R4 perf: throttle to at most once per paint via rAF (matching the
      // established header.js/quickLinks.js pattern).
      let scrollTicking = false;
      CONSTANT.eventsListners.WINDOW.onscroll = function () {
        if (scrollTicking) {return;}
        scrollTicking = true;
        window.requestAnimationFrame(function () {
          const windowTop = $(window).scrollTop();

          if (windowTop >= stickyTop) {
            $stickyElement.addClass("custom-sticky");
            if ($(window).width() < 768) {
              browseArticle.variables.articleSwiperWrap.removeClass("pl");
              browseArticle.variables.swiperElem.params.slidesPerView = 1.4;
              browseArticle.variables.swiperElem.update();
            }
          } else if ($stickyElement.hasClass("custom-sticky")) {
            $stickyElement.removeClass("custom-sticky");
            if ($(window).width() < 768) {
              browseArticle.variables.articleSwiperWrap.addClass("pl");
              browseArticle.variables.swiperElem.params.slidesPerView = 3.2;
              browseArticle.variables.swiperElem.update();
            }
          }
          scrollTicking = false;
        });
      };
    },
    sectionInView(entries) {
      // Skip observer-driven slide changes while the user has manually clicked
      // a slide — prevents double/triple shifting caused by multiple sections
      // crossing the 50% threshold during the anchor-scroll animation.
      if (browseArticle.variables.isManualClick) {return;}

      // Among all simultaneously intersecting entries pick the one most in view
      // to avoid two slideTo calls when two sections cross the threshold together.
      let bestEntry = null;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
            bestEntry = entry;
          }
        }
      });

      if (!bestEntry) {return;}

      const sectionId = bestEntry.target.id;
      const matchingSlideIndex = $(
        `.browse-article__swiper-wrapper--slide[href="#${sectionId}"]`
      ).index();

      if (matchingSlideIndex !== -1) {
        const spv = browseArticle.variables.swiperElem.params.slidesPerView;
        const offset = Math.floor((spv - 1) / 2);
        browseArticle.variables.swiperElem.slideTo(Math.max(0, matchingSlideIndex - offset));
        $(".browse-article__swiper-wrapper--slide").removeClass("selected");
        $(`.browse-article__swiper-wrapper--slide`)
          .eq(matchingSlideIndex)
          .addClass("selected");
      }
    },
    initObserver() {
      const options = {
        root: null,
        threshold: 0.5,
      };

      browseArticle.variables.observer = new IntersectionObserver(
        browseArticle.methods.sectionInView,
        options
      );


      browseArticle.variables.sections.forEach((section) => {
        browseArticle.variables.observer.observe(section);
      });
    },

    init: () => {
      browseArticle.methods.scrollFunction();

      $(".browse-article").each((idx, element) => {
        browseArticle.methods.addSwiper(element);
        browseArticle.methods.handleClick(element);
        browseArticle.methods.slideClick(element);
        browseArticle.variables.sections = $(
          ".browse-article__swiper-wrapper--slide"
        ).map((idx, el) => {
          const sectionId = $(el).attr("href").replace("#", "");
          return document.getElementById(sectionId);
        }).get();

        browseArticle.methods.initObserver();
      });
    },
  },
};

$(() => {
  if ($("#browseArticleSection").length > 0) {
    browseArticle.methods.init();
  }
});
